// Modal de contacto: se abre desde cualquier [data-open-contact]. Sin JS,
// esos enlaces navegan a /contacto/, por lo que nada depende del script.
const FOCUSABLE = 'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])';

export function initContactModal() {
	const modal = document.querySelector("[data-contact-modal]");
	if (!modal) return;

	const triggers = document.querySelectorAll("[data-open-contact]");
	if (!triggers.length) return;

	const panel = modal.querySelector(".psyque-modal__panel");
	let previousFocus = null;

	const open = (event) => {
		event.preventDefault();
		previousFocus = document.activeElement;
		modal.hidden = false;
		document.body.classList.add("psyque-nav-open");
		panel?.querySelector(FOCUSABLE)?.focus();
	};

	const close = () => {
		modal.hidden = true;
		document.body.classList.remove("psyque-nav-open");
		if (previousFocus instanceof HTMLElement) previousFocus.focus();
	};

	triggers.forEach((trigger) => trigger.addEventListener("click", open));
	modal.querySelector("[data-modal-close]")?.addEventListener("click", close);
	modal.querySelector("[data-modal-backdrop]")?.addEventListener("click", close);

	document.addEventListener("keydown", (event) => {
		if (event.key === "Escape" && !modal.hidden) close();
	});

	// Foco contenido dentro del panel mientras está abierto.
	modal.addEventListener("keydown", (event) => {
		if (event.key !== "Tab" || !panel) return;
		const focusables = panel.querySelectorAll(FOCUSABLE);
		if (!focusables.length) return;
		const first = focusables[0];
		const last = focusables[focusables.length - 1];
		if (event.shiftKey && document.activeElement === first) {
			event.preventDefault();
			last.focus();
		} else if (!event.shiftKey && document.activeElement === last) {
			event.preventDefault();
			first.focus();
		}
	});
}
